import React, { useState } from "react";
import NameDisplay from "./NameDisplay";
import ProfileIcon from "../assets/icons/ic_profile.svg";
import ProfileArrow from "../assets/icons/ic_profilearrow.svg";
import storage from "../utils/storage";
import hamburgerIcon from '../assets/icons/hamburger.png';
import { useNavigate } from "react-router";
import { useDispatch } from 'react-redux';
import appActions from "../appActions";

const Header = ({ toggleSideBar }) => {

    const navigate = useNavigate();

    const dispatch = useDispatch();
    
    const [settings, setSettings] = useState({
        isThemeVisible: false,
        isNotificationVisible: false,
    });

    const handleLogout = () => {
        dispatch(appActions.AUTH_LOGOUT_SUCCESS());
        storage.clear();
        setTimeout(() => navigate("/login"), 0); // small defer to avoid race
    };
    const onSettingsClick = () => {
        setSettings({
            isThemeVisible: !settings.isThemeVisible,
            isNotificationVisible: false,
        });
    };

    return (
        <nav className="navbar navbar-expand-lg navbar-light flex item-center ">
            <div className="container-fluid ">
                <div className="row flex justify-between">
                    <div>
                        <img  src={hamburgerIcon}  onClick={toggleSideBar} alt="Toggle Sidebar" 
                            id="tooltip_menu" className="tp" data-pr-tooltip="Toggle Sidebar"
                            style={{ width: '30px', height: '30px', marginRight: '8px' }} 
                        />
                    </div>

                    <span className="sidebar-header" id="sidebar-header"></span>
                    <div className="ml-auto"  onClick={onSettingsClick}>
                        <span className="flex item-center">
                            <img alt="ProfileIcon" className="profile_img" src={ProfileIcon} />
                            {<NameDisplay />}
                            <img alt="ArrowDownImg" className="pv-15 ph-15" src={ProfileArrow} />
                        </span>
                    </div>

                    <div className={ settings.isThemeVisible ? "dropdown-custom display-block" : "dropdown-custom display-none"} >
                        <button className="dropdown-item" onClick={handleLogout} style={{ background: "none", border: "none", padding: 0, cursor: "pointer" }}>
                            Log Out
                        </button>
                    </div>
                </div>
            </div>
        </nav>
    );
};

export default Header;
